import { ChainlitAPI, ChainlitContext } from "@chainlit/react-client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RecoilRoot } from "recoil";
import { AuthProvider } from "./contexts/AuthContext";
import { SuperAdminAuthProvider } from "./contexts/SuperAdminAuthContext";
import { useContainer } from "./hooks/useContainer";
import { Router } from "./router/Router";
import { store } from "./store/store";
import { mui } from "./themes/theme";
import { BotFiltersProvider } from "./components/bot-filters/BotFiltersProvider";

export const App = () => {
  const { routes, config } = useContainer();

  const chainlitApiClient = new ChainlitAPI(
    `${config.chainlitServerUrl}`,
    "webapp",
  );

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={1500}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      preventDuplicate
    >
      <HelmetProvider>
        <ChainlitContext.Provider value={chainlitApiClient}>
          <RecoilRoot>
            <Provider store={store}>
              <ThemeProvider theme={mui}>
                <CssBaseline enableColorScheme />
                <AuthProvider>
                  <SuperAdminAuthProvider>
                    <BotFiltersProvider />
                    <Router routes={routes} />
                  </SuperAdminAuthProvider>
                </AuthProvider>
              </ThemeProvider>
            </Provider>
          </RecoilRoot>
        </ChainlitContext.Provider>
      </HelmetProvider>
    </SnackbarProvider>
  );
};

export default App;
